export default __webpack_public_path__ + "images/mail-robot-81c4de12a13053bf86b41b774acb82bb.svg";